import { render, staticRenderFns } from "./DetailsApproval.vue?vue&type=template&id=ff5c66ba&"
import script from "./DetailsApproval.vue?vue&type=script&lang=js&"
export * from "./DetailsApproval.vue?vue&type=script&lang=js&"
import style0 from "./DetailsApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff5c66ba')) {
      api.createRecord('ff5c66ba', component.options)
    } else {
      api.reload('ff5c66ba', component.options)
    }
    module.hot.accept("./DetailsApproval.vue?vue&type=template&id=ff5c66ba&", function () {
      api.rerender('ff5c66ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/modals/DetailsApproval.vue"
export default component.exports